var $ab8a6b7d65f035f8$exports = {};
$ab8a6b7d65f035f8$exports = {
    "valid": `\u{388}\u{3B3}\u{3BA}\u{3C5}\u{3C1}\u{3BF}`
};


export {$ab8a6b7d65f035f8$exports as default};
//# sourceMappingURL=el-GR.module.js.map
